<!--
    Styles
-->

<style>


    /* main */

    #app > .l-toasts {
        position: absolute;
        left: 0;
        top: 60px;
        width: 100%;
    }
    #app > .l-toasts .toast {
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 50%;
    }
    #app > .l-toasts .toast .move {
        pointer-events: auto;
        position: relative;
        left: -50%;
        padding: 10px 0;
    }
    #app > .l-toasts .toast:first-child {
        z-index: 1;
    }


    /* message */

    #app > .l-toasts .message {
        background: var(--cl-white);
        padding: 20px 30px;
        border-radius: 6px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
    }
    #app > .l-toasts .message svg {
        width: 36px;
        height: 36px;
        margin-right: 20px;
    }
    #app > .l-toasts .message p {
        flex-basis: auto; /* IE */
    }


    /* animations */

    #app > .l-toasts .toast {
        transition: transform 0.4s ease, opacity 0.4s ease;
    }
    #app > .l-toasts .toast .move {
        transition: transform 0.4s ease;
    }
    #app > .l-toasts .toast-enter {
        opacity: 0;
        transform: translateY(-25%);
    }
    #app > .l-toasts .toast-leave-active {
        z-index: -1;
    }
    #app > .l-toasts .toast-leave-to {
        opacity: 0;
        transform: translateY(25%);
    }


</style>



<!--
    Template
-->

<template>
    <transition-group class="l-toasts" name="toast" tag="div" @before-enter="showStart" @after-enter="showEnd" @mouseenter.native="toastsEnter" @mouseleave.native="toastsLeave" @after-leave="hideEnd">
        <div class="toast" v-for="(toast, index) in toasts" :key="toast.id" :id="index">
            <div class="move" :style="{transform: `translateY(${index * 100}%)`}">

                <a class="message u-row" @click="toastClick(toast)">
                    <component :is="icon[toast.type].component" :class="icon[toast.type].class" />
                    <p class="u-flex">{{ toast.message }}</p>
                </a>

            </div>
        </div>
    </transition-group>
</template>



<!--
    Scripts
-->

<script>


    import {mapState} from 'vuex';
    import iconInfo from '@/assets/icons/info.svg';
    import iconSuccess from '@/assets/icons/success.svg';


    const max = 2;


    export default {

        components: {
            iconInfo,
            iconSuccess
        },

        computed: mapState('toasts', [
            'queue'
        ]),

        data () {
            return {
                showing: false,
                hovered: false,
                toasts: [],
                icon: {
                    info: {
                        component: 'iconSuccess',
                        class: 'cl-blue'
                    },
                    warn: {
                        component: 'iconInfo',
                        class: 'cl-orange'
                    },
                    error: {
                        component: 'iconInfo',
                        class: 'cl-red'
                    }
                }
            }
        },

        methods: {

            toastsEnter () {
                this.hovered = true;
                this.toasts.forEach(toast => toast.pause());
            },

            toastsLeave () {
                this.hovered = false;
                this.toasts.slice().forEach(toast => toast.resume());
                !this.showing && this.update();
            },

            toastClick (toast) {
                if (this.showing && this.toasts[0] === toast) return; // do not remove appearing toast
                this.remove(toast);
                this.update();
            },

            showStart () {
                this.showing = true;
            },

            showEnd () {
                this.showing = false;
                !this.hovered && this.update();
            },

            hideEnd () {
                setTimeout(() => this.hovered && !this.$el.matches(':hover') && this.toastsLeave()); // trigger toastsLeave if element is not hovered anymore
            },

            update () {
                if (!this.queue.length) return;
                if (this.toasts.length === max) this.toasts.pop();
                const item = this.queue.shift();
                item.wait(this.remove);
                this.hovered && item.pause();
                this.toasts.unshift(item);
            },

            add () {
                if (this.showing) return;
                this.update();
            },

            remove (toast) {
                const index = this.toasts.indexOf(toast);
                if (index === -1) return;
                this.toasts.splice(this.toasts.indexOf(toast), 1);
            }

        },

        watch: {

            'queue.length': {
                immediate: true,
                handler (current, previous) {
                    if (current > previous) this.add(); // item is pushed to the queue
                }
            }
        }


    }


</script>
